import { render, staticRenderFns } from "./ResultsScreen.vue?vue&type=template&id=56cd0ff5&scoped=true"
import script from "./ResultsScreen.vue?vue&type=script&lang=js"
export * from "./ResultsScreen.vue?vue&type=script&lang=js"
import style0 from "./ResultsScreen.vue?vue&type=style&index=0&id=56cd0ff5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cd0ff5",
  null
  
)

export default component.exports